import { render, staticRenderFns } from "./ReplyBox.vue?vue&type=template&id=7a531d80&scoped=true"
import script from "./ReplyBox.vue?vue&type=script&lang=js"
export * from "./ReplyBox.vue?vue&type=script&lang=js"
import style0 from "./ReplyBox.vue?vue&type=style&index=0&id=7a531d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_webpack@5.108.4__lodash@4.18.1_prettier@3.9.5_vue-t_1661a82514c85892bee2ee9ef8290494/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a531d80",
  null
  
)

export default component.exports